import SpecialtyFileUploadSection from 'components/SpecialtyFileUploadSection';
import { SPECIALTY_FILE_TYPES } from 'constants/fileTypes';
import { useSpecialtyCarriers } from 'hooks/index';
import { useAppSelector } from 'hooks';

interface SpecialtyMVRUploadProps {
  isLocked?: boolean;
}

const SpecialtyMVRUpload = ({ isLocked = false }: SpecialtyMVRUploadProps) => {
  const lineOfBusiness = useAppSelector(
    (state) => state.specialtyForm.lineOfBusiness,
  );
  const { availableCarriers } = useSpecialtyCarriers(
    lineOfBusiness || undefined,
  );
  const selectedCarrierName = useAppSelector(
    (state) => state.specialtyForm.data.insurance_company,
  );

  const selectedCarrier = availableCarriers.find(
    (c) => c.name === selectedCarrierName,
  );
  const shouldShowMVR = selectedCarrier?.fileRequirements.mvrReport;

  if (!shouldShowMVR) {
    return null;
  }

  return (
    <SpecialtyFileUploadSection
      title="MVR Upload (per driver)"
      fieldLabel="Motor Vehicle Records (MVR)"
      fileType="mvr"
      fileTypeId={SPECIALTY_FILE_TYPES.MVR_REPORT}
      badgeText="MVR Report"
      acceptedFileTypes=".pdf,.doc,.docx"
      sectionId="sectionSpecialtyMVRUpload"
      isRequired={false}
      isLocked={isLocked}
    />
  );
};

export default SpecialtyMVRUpload;
